import { render, staticRenderFns } from "./ExpensesTotalCosts.vue?vue&type=template&id=09597a45"
import script from "./ExpensesTotalCosts.vue?vue&type=script&lang=js"
export * from "./ExpensesTotalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports